const DYNAMIC_FIELDS_SCHEME = [
    {
        'searchable_name': 'cf__company_name',
        'localized_name': 'Nom de l\'entreprise',
        'en_name': 'Company name',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
            min_length: 3,
            max_length: 6,
        },
    },
    {
        'searchable_name': 'cf__siren',
        'localized_name': 'SIREN',
        'en_name': 'SIREN',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
            min_length: 1,
            max_length: 40,
        },
    },
    {
        'searchable_name': 'cf__number_of_employees',
        'localized_name': 'Nombre d\'employés',
        'en_name': 'Number of employees',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
        },
    },
    {
        'searchable_name': 'cf__some_another_field',
        'localized_name': 'Qa field #1',
        'en_name': 'Qa field #1',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: false,
        },
    },
    {
        'searchable_name': 'cf__some_another_field_2',
        'localized_name': 'Qa field #2',
        'en_name': 'Qa field #2',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
        },
    },
    {
        'searchable_name': 'cf__some_another_field_3',
        'localized_name': 'Qa field #3',
        'en_name': 'Qa field #3',
        'order': null,
        'type': 'string',
        'validator': {},
    },
    {
        'searchable_name': 'cf__some_another_field_4',
        'localized_name': 'Qa field #4',
        'en_name': 'Qa field #4',
        'order': null,
        'type': 'string',
        'validator': {},
    },
    {
        'searchable_name': 'cf__some_another_field_5',
        'localized_name': 'Qa field #5',
        'en_name': 'Qa field #5',
        'order': null,
        'type': 'string',
        'validator': {
            min_length: 2,
            max_length: 4,
        },
    },
    {
        'searchable_name': 'cf__some_another_field_6',
        'localized_name': 'Qa field #6',
        'en_name': 'Qa field #6',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: false,
            min_length: 10,
            max_length: 14,
        },
    },
];
const DYNAMIC_FIELDS_SCHEME_2 = [
    {
        'searchable_name': 'cf__company_name',
        'localized_name': 'Nom de l\'entreprise',
        'en_name': 'Company name',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
            min_length: 3,
        },
    },
    {
        'searchable_name': 'cf__siren',
        'localized_name': 'SIREN',
        'en_name': 'SIREN',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
            max_length: 5,
        },
    },
    {
        'searchable_name': 'cf__number_of_employees',
        'localized_name': 'Nombre d\'employés',
        'en_name': 'Number of employees',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
            length: 3,
        },
    },
];
const DYNAMIC_FIELDS_SCHEME_3 = [
    {
        'searchable_name': 'cf__company_name',
        'localized_name': 'Nom de l\'entreprise',
        'en_name': 'Company name',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
            max_length: 3,
        },
    },
    {
        'searchable_name': 'cf__siren',
        'localized_name': 'SIREN',
        'en_name': 'SIREN',
        'order': null,
        'type': 'string',
        'validator': {
            max_length: 5,
            number_range: [10, 12],
        },
    },
    {
        'searchable_name': 'cf__number_of_employees',
        'localized_name': 'Nombre d\'employés',
        'en_name': 'Number of employees',
        'order': null,
        'type': 'string',
        'validator': {},
    },
    {
        'searchable_name': 'cf__some_another_field',
        'localized_name': 'Qa field #1',
        'en_name': 'Qa field #1',
        'order': null,
        'type': 'string',
        'validator': {
            number_range: [1, 4],
        },
    },
];
const DYNAMIC_FIELDS_SCHEME_4 = [
    {
        'searchable_name': 'cf__company_name',
        'localized_name': 'Nom de l\'entreprise',
        'en_name': 'Company name',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
            min_length: 3,
            max_length: 6,
        },
    },
    {
        'searchable_name': 'cf__siren',
        'localized_name': 'SIREN',
        'en_name': 'SIREN',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
            min_length: 1,
            max_length: 40,
        },
    },
    {
        'searchable_name': 'cf__number_of_employees',
        'localized_name': 'Nombre d\'employés',
        'en_name': 'Number of employees',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
        },
    },
    {
        'searchable_name': 'cf__some_another_field',
        'localized_name': 'Qa field #1',
        'en_name': 'Qa field #1',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: false,
        },
    },
    {
        'searchable_name': 'cf__some_another_field_2',
        'localized_name': 'Qa field #2',
        'en_name': 'Qa field #2',
        'order': null,
        'type': 'string',
        'validator': {
            input_required: true,
        },
    },
];
const MATMUT_FIELDS_SCHEME_1 = {
    defaultFormValues: {
        min_count: 0,
        slot: '',
        technician_id: '',
        priority: 0,
        distance_to_in_km_text: '1km',
        duration_to_in_min_text: '10',
        duration_from_in_min_text: '10',
        technician_detail_color: 'red',
        distance_to_in_meters: 20,
        id: '',
        appointment_count_per_day: 1,
    },
    client: {
        address: 'Avenue de France 74000 Annecy',
        branch_external_id: '',
        created_at: '',
        email: '',
        first_name: 'test_first_name_cy_booking_1',
        id: 'string',
        last_name: 'test_last_name_cy_booking_1',
        phone_number: '11111111',
        post_code: '74000',
        updated_at: '',
        latitude: '45.914414',
        longitude: '6.134643',
    },
    eventData: {
        min_count: 0,
        slot: '',
        technician_id: '',
        priority: 0,
        distance_to_in_km_text: '1km',
        duration_to_in_min_text: '10',
        duration_from_in_min_text: '10',
        technician_detail_color: 'red',
        distance_to_in_meters: 20,
        id: '',
        appointment_count_per_day: 1,
    },
    date: new Date('2024-11-03'),
    dates: ['2024-11-03', '2024-11-04'],
    canUpdateDisabledFields: false,
    isUpdateNowWithCurrentAdvisor: false,
    placeParsedData: {
        calizyAddress: 'Avenue de France 74000 Annecy',
        post_code: '74000',
        address: 'Avenue de France 74000 Annecy',
        country: 'France',
        latitude: 45.914414,
        longitude: 6.134643,
    },
    branchAddress: {
        address: 'Avenue de France 74000 Annecy',
        id: '',
        name: 'test_branch_cy_booking_1',
        external_id: '',
        branch_video_rooms: [
            {
                address: '',
                id: '',
                name: '',
            },
        ],
        post_code: '74000',
    },
    post_code: '74000',
    country_iso: 'FRA',
    start_email: '',
    start_phone_number: '',
    selectedAdvisor: {
        name: '',
        last_name: '',
        color: '',
        pro_title: '',
        id: null,
        disabled: false,
    },
};
export const BOOKING_FORM_SCHEMA_COMMON = [
    {
        'searchable_name': 'booking__first_name',
        'localized_name': 'Prénom',
        'en_name': 'First name',
        'order': null,
        'type': 'string',
        'validator': { 'input_required': true, 'min_length': 1, 'max_length': 20 },
        'qa_class': 'qa-booking-form-first-name',
    },
    {
        'searchable_name': 'booking__last_name',
        'localized_name': 'Nom',
        'en_name': 'Last name',
        'order': null,
        'type': 'string',
        'validator': { 'input_required': true, 'min_length': 2, 'max_length': 30 },
        'qa_class': 'qa-booking-form-last-name',
    },
    {
        'searchable_name': 'booking__company',
        'localized_name': 'Société',
        'en_name': 'Company',
        'order': null,
        'type': 'string',
        'validator': {},
        'qa_class': 'qa-booking-form-company',
    },
    {
        'searchable_name': 'booking__phone_number',
        'localized_name': 'Numérique',
        'en_name': 'Phone number',
        'order': null,
        'type': 'number',
        'validator': { 'input_required': true },
        'qa_class': 'qa-booking-form-phone-number',
    },
    {
        'searchable_name': 'booking__email',
        'localized_name': 'Email',
        'en_name': 'Email',
        'order': null,
        'type': 'text',
        'validator': { 'input_required': true },
        'qa_class': 'qa-booking-form-email',
    },
    {
        'searchable_name': 'booking__client_post_code',
        'localized_name': 'Client Postal Code',
        'en_name': 'Client Postal Code',
        'order': null,
        'type': 'text',
        'validator': { 'min_length': 3, 'max_length': 10 },
        'qa_class': 'qa-booking-form__post-code-common',
    },
    {
        'searchable_name': 'booking__notes',
        'localized_name': 'Notes',
        'en_name': 'Notes',
        'order': null,
        'type': 'string',
        'validator': { 'input_required': true, 'min_length': 0, 'max_length': 500 },
        'qa_class': 'qa-booking-form__notes',
    },
];
export const BOOKING_FORM_SCHEMA_IS_APGIS_ACCOUNT = [
    {
        'searchable_name': 'booking__company',
        'localized_name': 'Société',
        'en_name': 'Company',
        'order': null,
        'type': 'string',
        'validator': {},
        'qa_class': 'qa-booking-form-company',
    },
];
export const BOOKING_FORM_SCHEMA_GEO_SCOPE_INTERNATIONAL_WITH_COUNTRIES = [
    {
        'searchable_name': 'booking__country_iso',
        'localized_name': 'Country ISO',
        'en_name': 'Country ISO',
        'order': null,
        'type': 'string',
        'validator': { 'input_required': true, 'min_length': 2, 'max_length': 2 },
        'qa_class': 'qa-booking-form-country-iso',
    },
    {
        'searchable_name': 'booking__post_code',
        'localized_name': 'Postal Code',
        'en_name': 'Postal Code',
        'order': null,
        'type': 'text',
        'validator': { 'input_required': true },
        'qa_class': 'qa-booking-form-post-code',
    },
    {
        'searchable_name': 'booking__client_post_code',
        'localized_name': 'Client Postal Code',
        'en_name': 'Client Postal Code',
        'order': null,
        'type': 'text',
        'validator': { 'input_required': true },
        'qa_class': 'qa-booking-form-client-post-code',
    },
];
export const BOOKING_FORM_SCHEMA_IS_BOOK_CALENDAR_ON_SITE = [
    {
        'searchable_name': 'booking__address_field_text',
        'localized_name': 'Address',
        'en_name': 'Address',
        'order': null,
        'type': 'text',
        'validator': { 'input_required': true },
        'qa_class': 'qa-booking-form-address-field-text',
    },
    {
        'searchable_name': 'booking__country',
        'localized_name': 'Country',
        'en_name': 'Country',
        'order': null,
        'type': 'string',
        'validator': { 'input_required': true, 'min_length': 2, 'max_length': 2 },
        'qa_class': 'qa-booking-form-country',
    },
];
const slotDate = new Date();
slotDate.setDate(slotDate.getDate() + 1);
slotDate.setUTCHours(15, 0, 0, 0);
const MOCK_TIME_SLOT_DATA = [{
        'slot': slotDate.toISOString(),
        'technician_id': 'd381f43c-b3a0-438e-a22d-59f8b70aa080',
        'appointment_count_per_day': 0,
        'technician_detail_color': '#FFBE00 - #FFC500',
    }];
export { DYNAMIC_FIELDS_SCHEME, DYNAMIC_FIELDS_SCHEME_2, DYNAMIC_FIELDS_SCHEME_3, DYNAMIC_FIELDS_SCHEME_4, MATMUT_FIELDS_SCHEME_1, MOCK_TIME_SLOT_DATA, };
